import { render, staticRenderFns } from "./EventWizard_EventDetails.vue?vue&type=template&id=509e2166&scoped=true&"
import script from "./EventWizard_EventDetails.vue?vue&type=script&lang=js&"
export * from "./EventWizard_EventDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventWizard_EventDetails.vue?vue&type=style&index=0&id=509e2166&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e2166",
  null
  
)

export default component.exports